import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { APP_CONFIG } from './app.config';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

var href =
  window.location.host.includes('recette') || window.location.host.includes('integration')
    ? '/Applicom/'
    : '/'

fetch(href + 'assets/app-config/config.json')
  .then((response) => response.json())
  .then((config) => {
    if (environment.production) {
      enableProdMode();
    }

    platformBrowserDynamic([{ provide: APP_CONFIG, useValue: config }])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
